import React, { useState } from 'react';

const ContactUs = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('Student Internship & Project Mentorship');
    const [message, setMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent('nandhakumar@arivunest.com')}&su=${encodeURIComponent(`[Website Inquiry] ${subject} - ${name}`)}&body=${encodeURIComponent(`Name: ${name}\nEmail: ${email}\nInquiry Type: ${subject}\n\nMessage:\n${message}\n`)}`;
        window.open(gmailUrl, '_blank', 'noopener,noreferrer');
        setSubmitted(true);
    };

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <div style={styles.badge}>GET IN TOUCH</div>
                <h1 style={styles.title}>Contact Arivu Nest Research and Development</h1>
                <p style={styles.subtitle}>Institutional Correspondence, Research Collaborations, Student Internships & Support</p>
            </header>

            <div style={styles.grid}>
                {/* Contact Information & Centers */}
                <div style={styles.infoCol}>
                    <div style={styles.infoCard}>
                        <h3 style={styles.cardHeading}>🏛️ Operating Centers & Addresses</h3>
                        
                        <div style={styles.addressBlock}>
                            <strong>Arivu Nest – Research and Development:</strong>
                            <p style={styles.addressText}>
                                64, Dhanoosh Kodiyapuram Puthu Theru,<br />
                                Kovilpatti, Tamil Nadu &ndash; 628501
                            </p>
                        </div>

                        <div style={styles.addressBlock}>
                            <strong>Jjegan Graphers (Patron & MSME Entity):</strong>
                            <p style={styles.addressText}>
                                Virudhunagar, Tamil Nadu<br />
                                <span style={styles.udyamBadge}>Udyam Reg. No: UDYAM-TN-32-0048110</span>
                            </p>
                        </div>
                    </div>

                    <div style={styles.infoCard}>
                        <h3 style={styles.cardHeading}>✉️ Official Email Channels</h3>
                        <div style={styles.emailItem}>
                            <strong>Executive & Academic Collaborations:</strong><br />
                            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=dr.sabitha@arivunest.com" target="_blank" rel="noopener noreferrer" style={styles.emailLink}>dr.sabitha@arivunest.com</a>
                        </div>
                        <div style={styles.emailItem}>
                            <strong>Operations, Secretariat & Support:</strong><br />
                            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=nandhakumar@arivunest.com" target="_blank" rel="noopener noreferrer" style={styles.emailLink}>nandhakumar@arivunest.com</a>
                        </div>
                        <div style={styles.emailItem}>
                            <strong>Kani Rathnam Equality Foundation:</strong><br />
                            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=kanirathinamfoundation@gmail.com" target="_blank" rel="noopener noreferrer" style={styles.emailLink}>kanirathinamfoundation@gmail.com</a>
                        </div>
                    </div>

                    <div style={{ ...styles.infoCard, background: '#f0fdf4', border: '1.5px solid #a7f3d0' }}>
                        <h3 style={{ ...styles.cardHeading, color: '#047857' }}>💬 Direct WhatsApp Community</h3>
                        <p style={{ margin: '0 0 14px', fontSize: '13.5px', color: '#166534', lineHeight: '1.5' }}>
                            Join our official Arivu Nest R&D Forum WhatsApp Community for immediate announcements, webinars, and orientation updates.
                        </p>
                        <a 
                            href="https://chat.whatsapp.com/E79PDHbC0n286T9ChYsgXo" 
                            target="_blank" 
                            rel="noreferrer" 
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#25D366', color: '#ffffff', textDecoration: 'none', padding: '10px 18px', borderRadius: '8px', fontWeight: '700', fontSize: '13.5px', boxShadow: '0 4px 12px rgba(37, 211, 102, 0.25)' }}
                        >
                            <span>💬</span> Open WhatsApp Forum
                        </a>
                    </div>

                    <div style={{ ...styles.infoCard, background: '#fdf2f8', border: '1.5px solid #fbcfe8' }}>
                        <h3 style={{ ...styles.cardHeading, color: '#be185d' }}>📸 Official Instagram Handle</h3>
                        <p style={{ margin: '0 0 14px', fontSize: '13.5px', color: '#9d174d', lineHeight: '1.5' }}>
                            Follow <strong>@arivunest_official</strong> for faculty spotlights, research highlights, and student internship circulars.
                        </p>
                        <a 
                            href="https://www.instagram.com/arivunest_official/" 
                            target="_blank" 
                            rel="noreferrer" 
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)', color: '#ffffff', textDecoration: 'none', padding: '10px 18px', borderRadius: '8px', fontWeight: '700', fontSize: '13.5px', boxShadow: '0 4px 12px rgba(220, 39, 67, 0.25)' }}
                        >
                            <span>📸</span> Follow @arivunest_official
                        </a>
                    </div>

                    <div style={{ ...styles.infoCard, background: '#fef2f2', border: '1.5px solid #fecaca' }}>
                        <h3 style={{ ...styles.cardHeading, color: '#dc2626' }}>▶️ Official YouTube Channel</h3>
                        <p style={{ margin: '0 0 14px', fontSize: '13.5px', color: '#991b1b', lineHeight: '1.5' }}>
                            Subscribe to <strong>@arivunestofficial</strong> for academic lectures, research symposiums, and student orientation webinars.
                        </p>
                        <a 
                            href="https://www.youtube.com/@arivunestofficial" 
                            target="_blank" 
                            rel="noreferrer" 
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#FF0000', color: '#ffffff', textDecoration: 'none', padding: '10px 18px', borderRadius: '8px', fontWeight: '700', fontSize: '13.5px', boxShadow: '0 4px 12px rgba(255, 0, 0, 0.25)' }}
                        >
                            <span>▶️</span> Subscribe @arivunestofficial
                        </a>
                    </div>

                    <div style={{ ...styles.infoCard, background: '#f0f9ff', border: '1.5px solid #bae6fd' }}>
                        <h3 style={{ ...styles.cardHeading, color: '#0369a1' }}>💼 Official LinkedIn Network</h3>
                        <p style={{ margin: '0 0 14px', fontSize: '13.5px', color: '#075985', lineHeight: '1.5' }}>
                            Connect with <strong>Arivu Nest</strong> on LinkedIn to network with our 49+ council professors, deans, and research scholars.
                        </p>
                        <a 
                            href="https://www.linkedin.com/in/arivunestofficial/" 
                            target="_blank" 
                            rel="noreferrer" 
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#0077b5', color: '#ffffff', textDecoration: 'none', padding: '10px 18px', borderRadius: '8px', fontWeight: '700', fontSize: '13.5px', boxShadow: '0 4px 12px rgba(0, 119, 181, 0.25)' }}
                        >
                            <span>💼</span> Connect on LinkedIn
                        </a>
                    </div>
                </div>

                {/* Direct Message Form */}
                <form onSubmit={handleSubmit} style={styles.formCard}>
                    <h3 style={{ margin: '0 0 16px', fontSize: '20px', color: '#0f172a' }}>Send Us a Direct Message</h3>
                    <p style={{ margin: '0 0 20px', fontSize: '13.5px', color: '#64748b' }}>
                        Fill in your details below and our team will get back to you promptly.
                    </p>

                    {submitted && (
                        <div style={{ background: '#ecfdf5', border: '1px solid #a7f3d0', padding: '12px 16px', borderRadius: '8px', marginBottom: '18px', color: '#047857', fontSize: '13.5px' }}>
                            ✓ Thank you! Gmail compose has been launched in a new tab with your inquiry details.
                        </div>
                    )}

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Your Full Name</label>
                        <input 
                            type="text" 
                            required
                            placeholder="e.g. S. Nandhakumar" 
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            style={styles.input} 
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Email Address</label>
                        <input 
                            type="email" 
                            required
                            placeholder="e.g. name@example.com" 
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={styles.input} 
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Subject / Nature of Inquiry</label>
                        <select 
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            style={styles.input}
                        >
                            <option>Institutional MoU & College Partnership</option>
                            <option>Advisory Board & Council Membership</option>
                            <option>Academic Research Collaboration & Publications</option>
                            <option>Corporate & MSME R&D Consultancy</option>
                            <option>Faculty Development Program (FDP) / Workshop</option>
                            <option>Student Internship & Project Mentorship</option>
                            <option>Certificate Verification Assistance</option>
                            <option>Other Institutional Inquiries</option>
                        </select>
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Your Message</label>
                        <textarea 
                            rows="4" 
                            required
                            placeholder="How can our team assist you?" 
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            style={styles.input}
                        ></textarea>
                    </div>

                    <button type="submit" style={styles.btn}>Submit Inquiry &rarr;</button>
                </form>
            </div>
        </div>
    );
};

const styles = {
    container: { maxWidth: '1100px', margin: '0 auto', padding: 'clamp(40px, 6vw, 80px) 20px', fontFamily: "'Inter', sans-serif" },
    header: { textAlign: 'center', marginBottom: '50px' },
    badge: { display: 'inline-block', background: '#ecfdf5', color: '#047857', border: '1px solid #a7f3d0', padding: '5px 14px', borderRadius: '999px', fontSize: '11px', fontWeight: '800', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '14px' },
    title: { fontSize: 'clamp(26px, 5vw, 38px)', color: '#0f172a', fontWeight: '800', margin: '0 0 10px 0', letterSpacing: '-0.5px' },
    subtitle: { fontSize: '15px', color: '#059669', fontWeight: '600' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '32px' },
    infoCol: { display: 'flex', flexDirection: 'column', gap: '20px' },
    infoCard: { background: '#f8fafc', border: '1.5px solid #e2e8f0', borderRadius: '14px', padding: '24px' },
    cardHeading: { margin: '0 0 16px 0', fontSize: '16px', fontWeight: '800', color: '#0f172a' },
    addressBlock: { marginBottom: '16px' },
    addressText: { margin: '4px 0 0 0', color: '#475569', fontSize: '13.5px', lineHeight: '1.6' },
    udyamBadge: { display: 'inline-block', background: '#e2e8f0', padding: '2px 8px', borderRadius: '4px', fontSize: '11.5px', fontFamily: 'monospace', color: '#0f172a', marginTop: '4px' },
    emailItem: { marginBottom: '12px' },
    emailLink: { color: '#059669', textDecoration: 'none', fontWeight: '700', fontSize: '14px' },
    formCard: { background: '#ffffff', padding: '32px', borderRadius: '14px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', border: '1.5px solid #e2e8f0' },
    inputGroup: { marginBottom: '16px' },
    label: { display: 'block', fontSize: '12.5px', fontWeight: '700', color: '#334155', marginBottom: '6px' },
    input: { width: '100%', padding: '12px 14px', border: '1.5px solid #cbd5e1', borderRadius: '8px', fontFamily: 'inherit', fontSize: '14px', boxSizing: 'border-box' },
    btn: { width: '100%', padding: '14px', background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)', color: '#ffffff', border: 'none', borderRadius: '8px', fontWeight: '700', fontSize: '15px', cursor: 'pointer', boxShadow: '0 4px 12px rgba(5, 150, 105, 0.25)' }
};

export default ContactUs;
